module.exports = __webpack_public_path__ + "static/media/tandi.61db5802.png";